export default __webpack_public_path__ + "static/cekmekoy-rest-2-eaaf50fa21fdfd9d776f96e9c3e115ae.jpg";